import {Action, createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Permission} from './permission.model';
import * as PermissionActions from './permission.actions';

export const permissionsFeatureKey = 'permissions';

export interface State extends EntityState<Permission> {
  // additional entities state properties
}

export function sortByPermissionName(a: Permission, b: Permission): any {
  return a?.name.localeCompare(b?.name);
}

export const adapter: EntityAdapter<Permission> = createEntityAdapter<Permission>({
  // sortComparer: sortByPermissionName
});

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

const permissionReducer = createReducer(
  initialState,
  on(PermissionActions.addPermission,
    (state, action) => adapter.addOne(action.permission, state)
  ),
  on(PermissionActions.upsertPermission,
    (state, action) => adapter.upsertOne(action.permission, state)
  ),
  on(PermissionActions.addPermissions,
    (state, action) => adapter.addMany(action.permissions, state)
  ),
  on(PermissionActions.upsertPermissions,
    (state, action) => adapter.upsertMany(action.permissions, state)
  ),
  on(PermissionActions.updatePermission,
    (state, action) => adapter.updateOne(action.permission, state)
  ),
  on(PermissionActions.updatePermissions,
    (state, action) => adapter.updateMany(action.permissions, state)
  ),
  on(PermissionActions.deletePermission,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(PermissionActions.deletePermissions,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(PermissionActions.loadPermissions,
    (state, action) => adapter.setAll(action.permissions, state)
  ),
  on(PermissionActions.clearPermissions,
    state => adapter.removeAll(state)
  ),
);

export function reducer(state: State | undefined, action: Action) {
  return permissionReducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

// export entity selectors
export const getAllPermissions = selectAll;
export const getPermissionById = selectIds;
export const getPermissionEntities = selectEntities;
